import React from 'react';
import Translate, { translate } from '@securitize/ui-components/i18n/Translate';
import { Alert, Button, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import LaddaButton, { ZOOM_OUT } from 'react-ladda';
import ModalComponent from '../../../../../components/ModalComponent/ModalComponent';
import notVerifiedUser from './signAgreement.svg';

const SignInvestmentModal = (props) => {
  const {
    onToggle,
    isOpen,
    onConfirm,
    isLoading,
    isError,
    errorType,
    investValue,
    currency,
  } = props;

  const numberWithCommas = (x) => Number(x).toLocaleString();

  return (
    <ModalComponent
      title={translate('Texts.sign-investment', {
        investValue: numberWithCommas(investValue),
        currency,
      })}
      image={notVerifiedUser}
      isOpen={isOpen}
      onToggle={onToggle}
      name="SignInvestment"
    >
      <p className="font-16 m-0 text-center">
        <Translate translationKey="Texts.sign-investment-description" />
      </p>
      <ModalFooter className="border-0 p-0 flex-column mb-2">
        <LaddaButton
          disabled={isLoading}
          className="btn p-3 m-0 text-white issuer-button-primary btn-block max-width-330 font-16"
          loading={isLoading}
          data-style={ZOOM_OUT}
          onClick={onConfirm}
        >
          <Translate translationKey="Texts.sign-new-agreement" />
        </LaddaButton>
        <Button
          className="m-0 issuer-primary"
          color="link"
          size="lg"
          block
          onClick={onToggle}
        >
          <Translate translationKey="Texts.keep-old-agreement" />
        </Button>
      </ModalFooter>
      {
        isError && (
          <div className="mt-2 mb-0 form-group">
            <Alert color="danger mb-0 text-center">
              {errorType}
            </Alert>
          </div>
        )
      }
    </ModalComponent>
  );
};

SignInvestmentModal.defaultProps = {
  isLoading: false,
  onToggle: () => {},
  isError: false,
  errorType: '',
};

SignInvestmentModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onToggle: PropTypes.func,
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  errorType: PropTypes.string,
  investValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  currency: PropTypes.string.isRequired,
};

export default SignInvestmentModal;
